<template>
  <div>
    <v-btn
      color="primary"
      :min-width="150"
      :loading="loading"
      @click="btnClickHandler"
    >
      {{ $t("accountPage.coefficientTurnover.button") }}
    </v-btn>

    <v-dialog v-model="open" max-width="430">
      <v-card
        class="d-flex flex-column align-center justify-center pa-4 px-md-8 pt-md-16 pb-md-10 gray10"
        v-if="coefficientTurnoverData"
      >
        <v-icon
          v-if="coefficientTurnoverData.is_eligible"
          size="68"
          clr="var(--v-success-base)"
          >$checkMarkCircle</v-icon
        >
        <v-icon v-else size="68">$stockCircle</v-icon>
        <span class="font-Bold-16 mt-6">{{
          $t("accountPage.coefficientTurnover.upgradeTitle")
        }}</span>

        <p class=" font-Regular-14 gray2--text mt-6 text-center">
          {{
            coefficientTurnoverData.is_eligible
              ? $t(
                  "accountPage.coefficientTurnover.upgradeDescriptionCompleted"
                )
              : $t("accountPage.coefficientTurnover.upgradeDescription")
          }}
        </p>

        <v-card
          class="d-flex  align-center justify-center pa-4 gray8 "
          dir="ltr"
        >
          <span class="font-Bold-11 text-center">{{
            $t("accountPage.coefficientTurnover.formula.compensationTurnover")
          }}</span>
          <span class="px-4">=</span>
          <span class="font-Regular-11 text-center">{{
            $t("accountPage.coefficientTurnover.formula.assetMultiplier")
          }}</span>
          <span class="px-4">‍×</span>
          <span class="font-Regular-11 text-center">{{
            $t("accountPage.coefficientTurnover.formula.averageDifference")
          }}</span>
        </v-card>

        <div class="w-100" dir="rtl">
          <div class="d-flex align-center justify-space-between  mt-8 mb-2">
            <span class="font-Regular-12"
              >{{
                coefficientTurnoverData.equivalentTurnoverCompensationPercentage
              }}%</span
            >
            <span class="font-Regular-12">
              {{
                $t("accountPage.coefficientTurnover.progress.label", {
                  data:
                    coefficientTurnoverData.equivalentTurnoverCompensationValue
                })
              }}
            </span>
          </div>
          <v-progress-linear
            :value="
              coefficientTurnoverData.equivalentTurnoverCompensationPercentage
            "
            :color="coefficientTurnoverData.is_eligible ? 'green' : 'primary'"
          ></v-progress-linear>
          <span class="font-Regular-12 gray2--text">
            {{
              $t("accountPage.coefficientTurnover.progress.note", {
                data: coefficientTurnoverData.requiredTurnoverValue
              })
            }}
          </span>
        </div>

        <v-btn color="primary" @click="open = true" block class="mt-10">
          {{ $t("accountPage.coefficientTurnover.confirm") }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { UserService } from "@/services";
export default {
  name: "coefficientTurnover",
  data() {
    return {
      open: false,
      loading: false,
      coefficientTurnoverData: null
    };
  },

  methods: {
    async btnClickHandler() {
      this.loading = true;
      await UserService.getCoefficientTurnover()
        .then(res => {
          this.open = true;
          this.coefficientTurnoverData = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
